/* ── Kauf und Abo ───────────────────────────────────────────────────────── */

.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.625rem;
  margin: 0;
  padding: 0.625rem 0.75rem 0.625rem 1rem;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  animation: fade-up 0.5s var(--ease-out) both;
}

.banner--success {
  border-color: rgba(98, 240, 177, 0.35);
  background: rgba(98, 240, 177, 0.08);
  color: #c7fbe3;
}

.banner--info {
  border-color: rgba(139, 109, 255, 0.38);
  background: rgba(139, 109, 255, 0.1);
  color: #ddd3ff;
}

.banner--error {
  border-color: rgba(255, 90, 115, 0.35);
  background: rgba(255, 90, 115, 0.1);
  color: #ffc9d1;
}

.banner .icon-button {
  width: 1.75rem;
  height: 1.75rem;
  color: inherit;
}

.plan-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  width: fit-content;
  margin: 0;
  padding: 0.3125rem 0.75rem;
  border-radius: 999px;
  background: var(--gradient);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 650;
}

.plan__manage {
  display: grid;
  gap: 0.5rem;
}

.plan__status--warning {
  background: rgba(255, 200, 87, 0.1);
  color: var(--warning);
}

.plan--current {
  border-color: var(--line-strong);
}
